import { useWorkflowSession } from '../../../contexts/WorkflowSessionContext';

export function useWorkflowName(): string | undefined {
  const { workflowName } = useWorkflowSession();

  return workflowName || undefined;
}
